module.exports = __webpack_public_path__ + "static/media/background.3ecbb5e5.png";